import { Action } from 'redux';
import { createAsyncSelectors } from '@lib/selectors';
import { useAction } from '../useAction';
import { useAsyncState } from '../useAsyncState';

import { coreActions, PatchDataSecurityApplicationByIdRequest } from '@sonar-software/sonar-core';

export interface UseUpdateDataSecurityAppResult {
	isIdle: boolean;
	isReceived: boolean;
	isRequested: boolean;
	request: (request: PatchDataSecurityApplicationByIdRequest) => void;
	reset: () => Action;
}

const selectors = createAsyncSelectors((state) => state.core.dataSecurity.applications.byId.patch);

export function useUpdateDataSecurityApp(): UseUpdateDataSecurityAppResult {
	const { isIdle, isReceived, isRequested } = useAsyncState(selectors);

	const request = useAction(coreActions.requestPatchCoreDataSecurityApplicationsById);
	const reset = useAction(coreActions.resetPatchCoreDataSecurityApplicationsById);

	return {
		isIdle,
		isReceived,
		isRequested,
		request,
		reset
	};
}

useUpdateDataSecurityApp.selectors = selectors;
